import { connect, ConnectedProps } from 'react-redux'
import ModalCreateEdit from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import useLangData from '../../../../../../../utils/hooks/useLangData'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import { getActiveLangs } from '../../../../../../../utils/reducers/getters'
import { GroupVatPayload } from '../../../../../../../utils/reducers/globals/groupVats'
import useModalCreateProductLogic from '../../../../../../../utils/hooks/product/useModalCreateProductLogic'
import { ModifiedCreateProductModelType } from '../../../../../../../specificComponents/Product/types'
import useModalCreateProductSpecificPricesLogic from '../../../../../../../utils/hooks/product/useModalCreateProductSpecificPricesLogic'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import NewProductSpecificPricesTable from '../../../../../../../specificComponents/Product/NewProductSpecificPricesTable'
import ProductCategories from '../../../../../../../baseComponents/Product/ProductCategories'
import { OnChangeMainCategoryTy } from '../../../../../../../baseComponents/Product/ProductCategories/types'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'


interface ModalCreateAddonProps extends ModalEditComponentProps {
    customLocation?: string
 }

const ModalCreateAddon: React.FC<ModalCreateAddonProps & ReduxModalCreateAddon> = ({ userPermissions, allRowData, onSubmit, groupVats, customLocation, ...rest }) => {
    const { handleOnSubmit, handleOnError, onChangeMain } = useModalCreateProductLogic({ customLocation })
    const { t } = useTwinTranslation()
    const { changeLang, selectedLang, data, changeValCurrentLang } = useLangData({ myData: null, fieldsToLang: ['name'], keyValue: 'LangId' })
    const { dataPrices, setDataPrices, beforeSubmitAddSpecificPrices } = useModalCreateProductSpecificPricesLogic({})

    const fields: FormRender<ModifiedCreateProductModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                    value: selectedLang,
                    onChange: changeLang,
                    required: true
                },
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                    lang: selectedLang,
                    value: data?.['name'][selectedLang] ?? '',
                    onChange: (name) => changeValCurrentLang('name', name)
                },
                {
                    name: 'nameLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.name)
                },
                {
                    name: 'GroupVatId',
                    label: t('groupVat', 'Grupo de impuestos'),
                    component: 'CustomSelectWithSearchBar',
                    items: groupVats || {},
                    required: true
                },
                {
                    name: 'reference',
                    label: t('reference', 'referencia'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'categories',
                    component: 'Custom',
                    render: ModalAddonCategories,
                    extraProps: { onChangeMain }
                },
                {
                    name: 'image',
                    label: t('imageProduct', 'Imagen del producto'),
                    component: 'ImageInput',
                },
                {
                    name: 'productType',
                    component: 'InputHidden',
                    value: 5
                },
            ]
        }
    ]

    return (<ModalCreateEdit fields={fields} url={'/api/app/product/createProduct'} beforeSubmit={beforeSubmitAddSpecificPrices} translations={{
        title: t('createProductAddon', 'Crear Complemento'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} onSubmit={onSubmit ?? handleOnSubmit} onChangeError={handleOnError} {...rest} imagePath={['tmp']} className='notFlexAutoFormRender'>
        <div className='regular18 mb-20'>
            <TwinTrans transKey='prices'>Precios</TwinTrans>
        </div>
        <NewProductSpecificPricesTable dataPrices={dataPrices} setDataPrices={setDataPrices} />
    </ModalCreateEdit>)
}
interface ModalAddonCategoriesProps {
    extraProps: {
        onChangeMain: OnChangeMainCategoryTy
    }
}

const ModalAddonCategories: React.FC<ModalAddonCategoriesProps> = ({ extraProps }) => {
    return (<ProductCategories productType={5} selectedCategories={[1]} className='createproduct_categories' onChangeMain={extraProps.onChangeMain} />)
}

const modalCreateAddonDispatch = {
    setGroupVats: (payload: GroupVatPayload) => ({ type: 'CHANGE_GROUPVAT', payload }),
}

export type ReduxModalCreateAddon = ConnectedProps<typeof modalCreateAddonConnect>
const mapModalCreateAddonConnector = (state: AllReduxPayloads) => ({ groupVats: state.groupVats })
const modalCreateAddonConnect = connect(mapModalCreateAddonConnector, modalCreateAddonDispatch)

const modalCreateAddonConnectLoading = withLoading(ModalCreateAddon, [{ fetchUrl: '/api/app/config/vat/getAllGroupsVat', propName: 'groupVats', setFunctionName: 'setGroupVats' }])

const ModalCreateAddonConnect = modalCreateAddonConnect(modalCreateAddonConnectLoading)

export default ModalCreateAddonConnect